import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Box, 
  Container,
  Tab,
  Tabs
} from '@mui/material';
import { 
  DirectionsCar as CarIcon, 
  AccountTree as FlowIcon 
} from '@mui/icons-material';
import FlowEditor from './components/FlowEditor';
import CarManagement from './components/CarManagement';
import Bookings from './components/Bookings';

function App() {
  const [currentView, setCurrentView] = useState('cars'); // 'flow' or 'cars' - default to 'cars'

  const handleTabChange = (event, newValue) => {
    setCurrentView(newValue);
  };

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      bgcolor: '#f5f5f5'
    }}>
      <AppBar position="static" elevation={2} sx={{ bgcolor: '#1976d2' }}>
        <Toolbar>
          <CarIcon sx={{ mr: 2, fontSize: 32 }} />
          <Typography variant="h5" component="div" sx={{ flexGrow: 0, fontWeight: 600, mr: 2 }}>
            NKA Service Auto - Admin Panel
          </Typography>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Tabs 
              value={currentView} 
              onChange={handleTabChange}
              textColor="inherit"
              TabIndicatorProps={{
                style: { backgroundColor: 'white', height: 3 }
              }}
            >
            <Tab 
              icon={<CarIcon />} 
              iconPosition="start"
              label="Manage Cars" 
              value="cars"
              sx={{ 
                color: 'white', 
                fontWeight: 500,
                '&.Mui-selected': { color: 'white' }
              }}
            />
            <Tab
              label="Bookings"
              value="bookings"
              sx={{
                color: 'white',
                fontWeight: 500,
                '&.Mui-selected': { color: 'white' }
              }}
            />
            <Tab 
              icon={<FlowIcon />} 
              iconPosition="start"
              label="Flow Editor" 
              value="flow"
              sx={{ 
                color: 'white', 
                fontWeight: 500,
                '&.Mui-selected': { color: 'white' }
              }}
            />
          </Tabs>
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ flexGrow: 1, overflow: 'auto', py: 3 }}>
        <Container maxWidth="xl">
          {currentView === 'flow' ? <FlowEditor /> :
           currentView === 'bookings' ? <Bookings /> :
           <CarManagement />}
        </Container>
      </Box>
    </Box>
  );
}

export default App;
